//
//
//
//

export default {
  name: 'OccupationLocation',
  props: {
    profile: {
      type: Object,
      required: true
    }
  },
  computed: {
    value () {
      let str = ''

      if (this.profile?.occupation) {
        str += this.profile?.occupation
      }

      if (this.profile?.location || this.profile?.countryId) {
        str += ` ${this.$t('common.from')} `
      }

      if (this.profile?.location) {
        str += this.profile?.location
      }

      if (this.profile?.location && this.profile?.countryId) {
        str += ', '
      }

      if (this.profile?.countryId) {
        const countries = this.$store.state.util.countries
        const country = countries.find(c => c.id === this.profile?.countryId)
        if (country) {
          str += country.name
        }
      }

      return str
    }
  }
}
